/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_CancelledInputs */

const en_orders_cancelled = /** @type {(inputs: Orders_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order cancelled.`)
};

const es_orders_cancelled = /** @type {(inputs: Orders_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedido cancelado.`)
};

/**
* | output |
* | --- |
* | "Order cancelled." |
*
* @param {Orders_CancelledInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_cancelled = /** @type {((inputs?: Orders_CancelledInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_CancelledInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_cancelled(inputs)
	return es_orders_cancelled(inputs)
});